import { Injectable } from '@angular/core';
import { FilterMenuGroup } from '../models/filter-menu-group.model';

@Injectable({ providedIn: 'root' })
export class FilterStateService {
  private filterGroupsState: FilterMenuGroup[] = [];

  setFilters(groups: FilterMenuGroup[], contextKey?: string): void {
    this.filterGroupsState = JSON.parse(JSON.stringify(groups));
    const storageKey = contextKey ? `adap_filterGroupsState_${contextKey}` : 'adap_filterGroupsState';
    localStorage.setItem(storageKey, JSON.stringify(this.filterGroupsState));
  }

  getFilters(contextKey?: string): FilterMenuGroup[] {
    const storageKey = contextKey ? `adap_filterGroupsState_${contextKey}` : 'adap_filterGroupsState';
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      this.filterGroupsState = JSON.parse(stored);
    }
    return JSON.parse(JSON.stringify(this.filterGroupsState));
  }

  clearFilters(contextKey?: string): void {
    this.filterGroupsState = [];
    const storageKey = contextKey ? `adap_filterGroupsState_${contextKey}` : 'adap_filterGroupsState';
    localStorage.removeItem(storageKey);
  }
}
